import { makeService } from './api';

const service = makeService('dunning_levels');

export default service;